import {
  ELEMENTO_PATH,
  EMPRESA_PATH,
  GRAFICA_PATH,
  PROYECTO_PATH,
  REPORTES_PATH,
  SENSOR_PATH,
  TARJETA_PATH,
  USUARIO_PATH,
  LOGS_PATH,
  ROOT_PAGE_PATH,
} from "../routes/path";

export const menuItems = () => {
  return [
    {
      key: ROOT_PAGE_PATH,
      icon: "dashboard",
      label: "Dashboard",
      path: ROOT_PAGE_PATH,
    },
    {
      key: USUARIO_PATH,
      icon: "usuario",
      label: "Usuario",
      path: USUARIO_PATH,
    },
    {
      key: EMPRESA_PATH,
      icon: "empresa",
      label: "Empresa",
      path: EMPRESA_PATH,
    },
    {
      key: PROYECTO_PATH,
      icon: "proyecto",
      label: "Proyecto",
      path: PROYECTO_PATH,
    },
    {
      key: ELEMENTO_PATH,
      icon: "elemento",
      label: "Elemento",
      path: ELEMENTO_PATH,
    },
    {
      key: TARJETA_PATH,
      icon: "tarjeta",
      label: "Tarjeta",
      path: TARJETA_PATH,
    },
    {
      key: SENSOR_PATH,
      icon: "sensor",
      label: "Sensor",
      path: SENSOR_PATH,
    },
    {
      key: GRAFICA_PATH,
      icon: "grafica",
      label: "Gráfica",
      path: GRAFICA_PATH,
    },
    {
      key: REPORTES_PATH,
      icon: "reporte",
      label: "Reportes",
      path: REPORTES_PATH,
    },
    {
      key: LOGS_PATH,
      icon: "logs",
      label: "Logs",
      path: LOGS_PATH,
    },
  ];
};

export const menuItemsEmpresa = () => {
  return [
    {
      key: ROOT_PAGE_PATH,
      icon: "dashboard",
      label: "Dashboard",
      path: ROOT_PAGE_PATH,
    },
    {
      key: PROYECTO_PATH,
      icon: "proyecto",
      label: "Proyecto",
      path: PROYECTO_PATH,
    },
    {
      key: ELEMENTO_PATH,
      icon: "elemento",
      label: "Elemento",
      path: ELEMENTO_PATH,
    },
    {
      key: TARJETA_PATH,
      icon: "tarjeta",
      label: "Tarjeta",
      path: TARJETA_PATH,
    },
    {
      key: SENSOR_PATH,
      icon: "sensor",
      label: "Sensor",
      path: SENSOR_PATH,
    },
    {
      key: GRAFICA_PATH,
      icon: "grafica",
      label: "Gráfica",
      path: GRAFICA_PATH,
    },
    {
      key: REPORTES_PATH,
      icon: "reporte",
      label: "Reportes",
      path: REPORTES_PATH,
    },
  ];
};
